  <div class="modal-header border-0 m-0">
      <h2 style="text-align:center">Preview File</h2>   
      <button type="button" class="close pointer text-black" (click)="activeModal.dismiss('cancel click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
<div  id="pdf_file">
  </div>